import {Component, ViewChild} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {IUserData, MemberModel} from '../../../../../models/user.model';
import {MatSelect} from '@angular/material/select';
import {catchError, EMPTY, filter, Subscription, take} from 'rxjs';
import {ContractsService} from '../../../../../services/api/contracts.service';
import {MatDialogRef} from '@angular/material/dialog';

@Component({
    selector: 'add-member-form',
    templateUrl: './add-member-form.component.html',
    styleUrl: './add-member-form.component.scss'
})
export class AppAddMemberFormComponentMT {
    public addUserForm: FormGroup
    public isAddSignerBlocked: boolean = true
    public allMembers: MemberModel[] = []
    public membersFiltered: MemberModel[] = []
    public guidContract: string = ''
    @ViewChild('emailList') emailListRef!: MatSelect;
    private subscriptions: Subscription = new Subscription()

    constructor(
        public dialogRef: MatDialogRef<AppAddMemberFormComponentMT>,
        protected contractsService: ContractsService,
        private fb: FormBuilder
    ) {
        this.addUserForm = this.fb.group({
            filter: [''],
            emailUser: ['', {validators: [Validators.pattern(/^\S+@\S+\.\S+$/), Validators.required]}],
            privateUser: ''
        })
    }

    get emailUser() {
        return this.addUserForm.get('emailUser')
    }

    // get privateUser () {return this.addUserForm.get('privateUser')}
    get filter() {
        return this.addUserForm.get('filter')
    }

    ngOnInit(): void {
        this.membersFiltered = this.allMembers;
        this.subscriptions.add(this.filter?.valueChanges.pipe(filter(fl => fl !== '' && this.addUserForm.enabled)).subscribe(filter => {
            this.emailListRef.open()
            this.membersFiltered = this.allMembers
                .filter(member => (member.firstname?.toLowerCase() + member.lastname?.toLowerCase() + member.email.toLowerCase()).includes(filter.toLowerCase()))
        }))
    }

    ngAfterViewInit(): void {
        this.subscriptions.add(this.emailListRef.selectionChange.subscribe(email => this.emailUser?.patchValue(email.value === 'another' ? '' : email.value)))
    }

    addUser(memberType: 'signer' | 'observer') {
        if (this.addUserForm.valid && this.guidContract) {
            this.addUserForm.disable();
            let userData: IUserData = {
                member_email: this.emailUser?.value,
                project_guid: null,
                can_verify: memberType === 'signer',
                // private_member:this.privateUser.value
            }
            this.contractsService.addMemberToContract(this.guidContract, userData)
                .pipe(
                    take(1),
                    catchError(e => {
                        this.dialogRef.close({error: e.message})
                        return EMPTY
                    }))
                .subscribe(data => this.dialogRef.close({...data, email: this.emailUser?.value}));
        }
    }
}